"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionRuntime = void 0;
/**
 * Responsible for extension runtime interactions such as messaging and etc.
 * Do not contains something application-specific, can be moved outside.
 */
const constants_1 = require("@/app/shared/constants");
exports.ExtensionRuntime = new (class {
    addReactMessageListener(type, listener, isAsynchronous = false) {
        const innerListener = (message) => {
            if (message.data.type === type) {
                listener(message.data);
                return isAsynchronous;
            }
        };
        window.addEventListener('message', innerListener);
        return () => {
            window.removeEventListener('message', innerListener);
        };
    }
    async sendMessage({ type, target = constants_1.MessageTarget.REGULAR, payload, }) {
        if (window.parent === window)
            return;
        window.parent.postMessage({ target, type, payload }, '*');
    }
})();
